import styled from 'styled-components';
import {Button} from '@ui/atoms/button';
import {getColorFromTheme} from '@ui/ui-utils';

export const GeneralPage = styled.main`
  width: 100%;
  min-width: 0;
  margin: 0 auto;
`;

export const GeneralPageIntro = styled.header`
  margin-bottom: 16px;

  h1 {
    margin: 0 0 6px;
    color: ${getColorFromTheme('blackTwo')};
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
  }

  p {
    margin: 0;
    color: ${getColorFromTheme('textBody')};
    font-size: 16px;
    line-height: 24px;
  }
`;

export const GeneralStack = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 24px;
`;

export const SettingsCard = styled.section`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  background: ${getColorFromTheme('white')};
`;

export const WorkspaceCardBody = styled.div`
  padding: 24px;

  @media (max-width: 600px) {
    padding: 20px 16px;
  }
`;

export const WorkspaceAvatar = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 0 36px 12px;

  > img,
  > div:first-child {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
  }
`;

export const WorkspaceAvatarFallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${getColorFromTheme('textBody')};
  background: ${getColorFromTheme('backgroundDark')};
  font-size: 24px;
  font-weight: 600;
`;

export const WorkspaceAvatarAction = styled(Button)`
  position: absolute;
  bottom: -12px;
  left: 50%;
  min-width: max-content;
  height: 28px;
  padding: 4px 12px;
  transform: translateX(-50%);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const SectionIntro = styled.div`
  margin-bottom: 24px;

  h2 {
    margin: 0 0 4px;
    color: ${getColorFromTheme('blackTwo')};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  p {
    margin: 0;
    color: ${getColorFromTheme('textBody')};
    font-size: 14px;
    line-height: 22px;
  }
`;

export const WorkspaceFields = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 760px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const WorkspaceField = styled.div`
  min-width: 0;
`;

export const WorkspaceActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
`;

export const SaveChangesButton = styled(Button)`
  min-height: 46px;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;

  &:disabled:not([aria-busy='true']) {
    border-color: transparent;
    color: ${getColorFromTheme('textMuted')};
    background: ${getColorFromTheme('backgroundDark')};
  }
`;
